import sendApiRequest from "../../apiRequestHandler";

// TODO: convert to type when BFF can accept string values instead of numbers
export enum LogLevel {
  Trace,
  Debug,
  Information,
  Warning,
  Error,
  Critical,
  None,
}

export interface Log {
  message: string;
  level: LogLevel;
}

export interface LogRequest extends Log {
  source: string;
}

export async function logPost(log: Log) {
  const fullPath = "logs";
  const request: LogRequest = { ...log, source: "calculator-public-mfe" };

  try {
    await sendApiRequest(fullPath, "POST", undefined, null, JSON.stringify(request));
  } catch {
    console.error("Failed to send logs.");
  }
}
